// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_tGH","cls2":"Carousel-cls2_ebn Carousel-cls1_tGH"};